import { render, staticRenderFns } from "./UploadBtnDynamic.vue?vue&type=template&id=1c55e131&"
import script from "./UploadBtnDynamic.vue?vue&type=script&lang=js&"
export * from "./UploadBtnDynamic.vue?vue&type=script&lang=js&"
import style0 from "./UploadBtnDynamic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports